import { render } from "./Citas.vue?vue&type=template&id=13d4e12d&ts=true"
import script from "./Citas.vue?vue&type=script&lang=ts"
export * from "./Citas.vue?vue&type=script&lang=ts"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__